import {AfterViewInit, Component, ViewChild} from '@angular/core';
import {Searchbar, ViewController} from 'ionic-angular';
import {ImageContentForm} from '../../../content/image/form/image-content.form';
import {ImageListComponent} from '../../../list/components/image-list/image-list.component';
import {WindowService} from '../../services/window';

/**
 * Class for the ImageListingModalComponent
 * @class
 */
@Component({
  selector: 'advtech-image-listing-modal',
  templateUrl: './image-listing-modal.component.html',
})
export class ImageListingModalComponent implements AfterViewInit {

  /**
   * Title of this page
   * @type {string}
   */
  pageTitle: string = 'Add Image';

  /**
   * The image content form
   * @type {ImageContentForm}
   */
  form: ImageContentForm;

  /**
   * Reference to the search bar
   * @type {Searchbar}
   */
  @ViewChild('search')
  search: Searchbar;

  /**
   * The image listing component
   * @type {ImageListComponent}
   */
  @ViewChild('listingComponent')
  imageListComponent: ImageListComponent;

  /**
   * @constructor
   * @param {ViewController} viewCtrl
   * @param {WindowService} windowService
   */
  constructor(public viewCtrl: ViewController,
              private windowService: WindowService) {
  }

  /**
   * Set the search bar CSS to open
   * @returns {void}
   */
  ngAfterViewInit() {
    this.imageListComponent.contentClass.searchBarOpen = true;
    this.imageListComponent.contentClass.searchBarClosed = false;
  }

  /**
   * Searches the listing page for the specified image
   * @param {any} event The key up event
   * @returns {void}
   */
  hImageModalSearch(event: any) {
    this.stopImageRequests();
    this.imageListComponent.hSearch(this.search.value);
  }

  /**
   * On selecting an image, return its ImageEntity
   * @param {any} event The imageEntity
   * @returns {Promise<any>}
   */
  hSelectImage(event: any): Promise<any> {
    this.stopImageRequests();
    return this.viewCtrl.dismiss(event);
  }

  stopImageRequests() {
    if (this.windowService.window.stop !== undefined) {
      this.windowService.window.stop();
      this.windowService.window.activeXHRRequests = 0;
    } else if (document.execCommand !== undefined) {
      document.execCommand('Stop', false);
    }
  }

  /**
   * Dismisses the modal
   * @return {Promise<any>}
   */
  dismiss(): Promise<any> {
    this.stopImageRequests();
    return this.viewCtrl.dismiss({status: 'cancel'});
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/components/image-listing-modal/image-listing-modal.component.ts